<template>
    <div v-if="isShow" class="nav-header">
        <header class="l-nav clearfix">
            <slot name="left">
                <div class="nav-left">
                    <span class="iconfont icon-left" v-show="hasBack" @click="goBack" data-stat="标题栏-返回" data-spm="goback"></span>
                </div>
            </slot>
            <slot name="center">
                <h1 class="nav-title">{{title}}</h1>
            </slot>
            <slot name="right">
                <div class="nav-right">
                    <span class="nav-more"></span>
                </div>
            </slot>
        </header>
        <div></div>
    </div>
</template>

<script>
import browser from "cy_static/browser";
import nativeUtil from "cy_static/nativeUtil";
    export default {
        name: 'navHeader',
        props: ['title', 'referrer', 'back', "show"],
        data: function () {
            return {
                hasBack: (this.back || document.referrer) && !this.referrer,
                isShow: !browser.weixin && !browser.jfmore || this.show
            }
        },
        methods: {
            goBack () {
            	if (browser && browser.jfmore) {
		            nativeUtil.closeWebview();
		        } else {
		       	 	history.back();
		        }
            }
        }
    }
</script>
<style scoped>
    .nav-header{ height:50px;position: absolute;z-index: 998;}
    .nav-header header{ height: 50px;line-height: 50px;padding:0 10px; text-align:center; background:#ffffff; top:0; right:0; left:0; position:fixed; z-index:1; display:flex;border-bottom:thin solid rgb(204, 204, 204); }
    .nav-header .nav-left{ flex:.5; text-align:left; }
    .nav-header .nav-right{ flex:.5; text-align:right }
    .nav-header .nav-title{ overflow:hidden; text-overflow:ellipsis; white-space:nowrap; font-weight:400; -ms-flex:1; flex:1; font-size:.32rem;}

</style>
